import Vue from 'vue'

export const NotificationEB = new Vue({
    

})